import {HttpClient, HttpHeaders, HttpResponse} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {Country} from "../../store/state/order.state";
import {EmailConfig} from "../../app-settings-panel/configuration/email/email-parameters.model";
import {MaintenanceInfo} from "../../maintenance/banner/maintenance-banner.component";
import {dateToString} from "../date-functions";
import {Permission} from "../../app-settings-panel/user-management/user-management.component";
import {VersionInfo} from "../../../environments/version-info.model";
import {Moment} from "moment";

import {AutomaticTakeoverConfig} from "../../app-settings-panel/configuration/automatic-takeover/automatic-takeover.model";

export class AppSettingEndpoints {

	constructor(private http: HttpClient) {
	}

	getAutomaticTakeover(country: string): Observable<AutomaticTakeoverConfig> {
		return this.http.get<AutomaticTakeoverConfig>(`${environment.apiUrl}/app-settings/automatic-takeover/${country}`);
	}

	saveAutomaticTakeover(country: string, config: AutomaticTakeoverConfig): Observable<AutomaticTakeoverConfig> {
		return this.http.put<AutomaticTakeoverConfig>(`${environment.apiUrl}/app-settings/automatic-takeover/${country}`, config);
	}

	getCalculationConfig(countryCode: string): Observable<string> {
		const accBody: string = countryCode === 'NL' ? 'RVA' : 'ANAB';
		const url: string = `${environment.apiUrl}/app-settings/calculation/config/${accBody}/${countryCode}`;
		return this.http.get<string>(url);
	}

	modifyCalculationConfig(countryCode: string, config: string): Observable<any> {
		const accBody: string = countryCode === 'NL' ? 'RVA' : 'ANAB';
		let url: string = `${environment.apiUrl}/app-settings/calculation/config/${accBody}/${countryCode}`;
		return this.http.post(url, config, {headers: {'Content-Type': 'application/json'}})
	}

	getCountries(): Observable<Country[]> {
		const url: string = `${environment.apiUrl}/app-settings/countries`;
		return this.http.get<Country[]>(url);
	}

	getEmailConfig(): Observable<EmailConfig> {
		const url: string = `${environment.apiUrl}/app-settings/email/properties`
		return this.http.get<EmailConfig>(url);
	}

	modifyEmailConfig(config: EmailConfig): Observable<any> {
		const url: string = `${environment.apiUrl}/app-settings/email/properties`;
		return this.http.put(url, config, {headers: {'Content-Type': 'application/json'}})
	}

	issueMaintenanceInfo(info: MaintenanceInfo): Observable<any> {
		let url: string = `${environment.apiUrl}/app-settings/maintenance`;
		return this.http.put(url, info, {headers: new HttpHeaders({"Content-Type": "application/json;charset=UTF-8"})})
	}

	getKPIs(from: Moment, to: Moment, country: string, products: string[]) {
		const startDate: string = dateToString(from.toDate());
		const endDate: string = dateToString(to.toDate());
		const url: string = `${environment.apiUrl}/kpi/calculate?from=${startDate}&to=${endDate}&country=${country}&standards=${products}`;
		return this.http.get(url, {responseType: "json", observe: "body"});
	}

	getDefaultPermissions(countryCode: string, roles: string[]): Observable<Permission[]> {
		return this.http.get<Permission[]>(`${environment.apiUrl}/app-settings/account/default-permissions?roles=${roles.join(',')}&employeeCountry=${countryCode}`)
	}

	getUserPermissions(email: string): Observable<HttpResponse<Permission[]>> {
		const url: string = `${environment.apiUrl}/app-settings/account/permissions?user=${email}`
		return this.http.get<Permission[]>(url, {observe: "response"})
	}

	getMaintenanceInfo(): Observable<MaintenanceInfo> {
		return this.http.get<MaintenanceInfo>(`${environment.apiUrl}/app-settings/maintenance`);
	}

	getVersionInfo(): Observable<VersionInfo> {
		return this.http.get<VersionInfo>(`${environment.apiUrl}/app-settings/version`);
	}

	getSalesPeople(): Observable<{[country: string]: string[]}> {
		return this.http.get<{[country: string]: string[]}>(`${environment.apiUrl}/app-settings/other/sales-people`);
	}

	saveSalesPeople(salesPeopleMap: { [p: string]: string[] }): Observable<HttpResponse<any>> {
		return this.http.post(`${environment.apiUrl}/app-settings/other/sales-people`, salesPeopleMap, {headers: new HttpHeaders({"Content-Type": "application/json"}), observe: "response"});
	}
}
